module.exports = __webpack_public_path__ + "img/Bestelbonnen.b8f34df7.svg";